export default {
  'pages.layouts.userLayout.title': 'Hi~',
  'pages.getCaptchaSecondText': 'sec(s)',
  'pages.workbench.link': 'workbench',
  'pages.workbench.alertMessage':
    'Faster and stronger heavy-duty components have been released.',
  'pages.404.subTitle': 'Sorry, the page you visited does not exist.',
  'pages.404.buttonText': 'Back Home',
  'pages.admin.subPage.title': 'This page can only be viewed by Admin',
  'pages.admin.subPage.alertMessage':
    'Umi ui is now released, workbench to use npm run ui to start the experience.',
  'pages.searchTable.createForm.newRule': 'New Rule',
  'pages.searchTable.updateForm.ruleConfig': 'Rule configuration',
  'pages.searchTable.updateForm.basicConfig': 'Basic Information',
  'pages.searchTable.updateForm.ruleName.nameLabel': 'Rule Name',
  'pages.searchTable.updateForm.ruleName.nameRules':
    'Please enter the rule name!',
  'pages.searchTable.updateForm.ruleDesc.descLabel': 'Rule Description',
  'pages.searchTable.updateForm.ruleDesc.descPlaceholder':
    'Please enter at least five characters',
  'pages.searchTable.updateForm.ruleDesc.descRules':
    'Please enter a rule description of at least five characters!',
  'pages.searchTable.updateForm.ruleProps.title': 'Configure Properties',
  'pages.searchTable.updateForm.object': 'Monitoring Object',
  'pages.searchTable.updateForm.ruleProps.templateLabel': 'Rule Template',
  'pages.searchTable.updateForm.ruleProps.typeLabel': 'Rule Type',
  'pages.searchTable.updateForm.schedulingPeriod.title':
    'Set Scheduling Period',
  'pages.searchTable.updateForm.schedulingPeriod.timeLabel': 'Starting Time',
  'pages.searchTable.updateForm.schedulingPeriod.timeRules':
    'Please choose a start time!',
  'pages.searchTable.titleDesc': 'Description',
  'pages.searchTable.ruleName': 'Rule name is required',
  'pages.searchTable.titleCallNo': 'Number of Service Calls',
  'pages.searchTable.titleStatus': 'Status',
  'pages.searchTable.nameStatus.default': 'default',
  'pages.searchTable.nameStatus.running': 'running',
  'pages.searchTable.nameStatus.online': 'online',
  'pages.searchTable.nameStatus.abnormal': 'abnormal',
  'pages.searchTable.titleUpdatedAt': 'Last Scheduled at',
  'pages.searchTable.exception': 'Please enter the reason for the exception!',
  'pages.searchTable.titleOption': 'Option',
  'pages.searchTable.config': 'Configuration',
  'pages.searchTable.subscribeAlert': 'Subscribe to alerts',
  'pages.searchTable.title': 'Enquiry Form',
  'pages.searchTable.new': 'New',
  'pages.searchTable.chosen': 'chosen',
  'pages.searchTable.item': 'item',
  'pages.searchTable.totalServiceCalls': 'Total Number of Service Calls',
  'pages.searchTable.tenThousand': '0000',
  'pages.searchTable.batchDeletion': 'batch deletion',
  'pages.searchTable.batchApproval': 'batch approval',
  'pages.organizationAdmin.enterpriseOverview.title': 'Enterprise Overview',
  'pages.organizationAdmin.costCenter.accounts.title': 'Account Balance',
  'pages.organizationAdmin.enterpriseSettings.adminPermissions.title':
    'Admin Permissions',
  'pages.organizationAdmin.enterpriseCulture.brandConfig.title':
    'Brand Configuration',
  'pages.organizationAdmin.common.initialized':
    'Page initialized. Content is under construction.',
  'pages.organizationAdmin.aiUsage.usageOverview.title': 'AI Usage Overview',
  'pages.organizationAdmin.aiUsage.usageDetails.title': 'Usage Details',
  'pages.organizationAdmin.aiUsage.usageLogs.title': 'Usage Logs',
  'pages.organizationAdmin.aiUsage.quotaManagement.title': 'Quota Management',
  'pages.organizationAdmin.aiUsage.storageSpace.capacityOverview.title':
    'Capacity Overview',
  'pages.organizationAdmin.aiUsage.storageSpace.limitManagement.title':
    'Upper Limit Management',
  'pages.organizationAdmin.aiUsage.storageSpace.storageCleanup.title':
    'Storage Cleanup',
};
